(ns app.upload-manager.core
  (:require [cljs-http.client :as http]
            [cljs.core.async :as a :refer [<!]]
            [reagent.core :as r]
            [simplemono.segment-upload.upload-manager :as upload-manager]
            [simplemono.segment-upload.util :as upload-util])

  (:require-macros [cljs.core.async.macros :refer [go]]))

(defonce upload-id
         (r/atom 0))

(defonce upload-state
         (r/atom {:max-parallel-uploads 8}))

(defonce upload-reel-state
         (r/atom {:max-parallel-uploads 2}))

(defn- safe-drive!
  "Wraps upload-manager/drive! in a try-catch. The drive! function can throw
   when an upload is cleaned up concurrently between reading the upload map
   and invoking :compose-drive! on an upload entry that no longer exists."
  [a]
  (try
    (upload-manager/drive! a)
    (catch :default _)))

(defonce driver
         (js/setInterval (fn []
                           (safe-drive! (upload-util/atom->a upload-state))
                           (safe-drive! (upload-util/atom->a upload-reel-state)))
                         200))

(defn create-from-url!
  "Returns a channel that contains the response body of the
   `/api/blob/create-from-url` endpoint, or a `js/Error` if the request
   was not successful."
  [params]
  (go
    (let [response (<! (http/request
                         {:request-method :post
                          :url "/api/blob/create-from-url"
                          :transit-params params}))]
      (if (= (:status response)
             200)
        (:body response)
        ;; The status is part of the message, so that a user report or
        ;; a log line tells a server error (500) from a lost connection
        ;; (0) apart.
        (ex-info (str "Failed to create blob from url (status "
                      (:status response)
                      ")")
                 {:status (:status response)
                  :body (:body response)})))))

(defn upload-blob!
  [{:keys [blob manager-state]
    :as params
    :or {manager-state upload-state}}]
  (if blob
    (let [chan (a/chan)
          a (upload-util/atom->a manager-state)]
      (a (fn [w]
           (upload-manager/add-upload
             w
             (merge
               {:id (str (swap! upload-id
                                inc))
                :callback (fn [{:keys [url]}]
                            (a/go
                              (let [result (a/<! (create-from-url! {:blob/url url
                                                                    :blob/content-type (.-type blob)}))]
                                (a/>! chan
                                      (if (instance? js/Error result)
                                        result
                                        (or (:blob/uuid result)
                                            (ex-info "Blob upload did not return a blob uuid"
                                                     {:result result})))))))}
               params))))
      chan)
    (throw (ex-info "Blob is nil" {}))
    ))
